import React from "react";
import { useParams } from "react-router";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Spinner from "../../components/Reusable/Spinner";
import InvoiceSkeleton from "../../components/Reusable/InvoiceSkeleton";
import SwitchTab from "../../components/Reusable/SwitchTab";
const InvoicePreviewComponent = loadable(
  () => import("../../components/RiderInvoice/InvoicePreview")
);

const RiderInvoicePreview = () => {
  const { id } = useParams();

  const { data: order, isLoading } = useGetHook({
    queryKey: ["rider-invoice", `rider-invoice-${id}`],
    url: `${APIS.RIDER_INVOICE}${id}/`,
    params: {},
  });

  return (
    <>
      <SwitchTab id={id} />
      {isLoading ? (
        <InvoiceSkeleton />
      ) : (
        <InvoicePreviewComponent order={order} id={id} />
      )}
    </>
  );
};

export default RiderInvoicePreview;
